import { atom } from 'recoil';

export const dashboardScanByIntervalAtom = atom({
  key: 'dashboardScanByIntervalAtom',
  default: {
    loading: false,
    items: [],
    error: null
  },
});

export const dashboardRiskAtom = atom({
  key: 'dashboardRiskAtom',
  default: {
    loading: false,
    items: [],
    error: null
  },
});

export const dashboardAnalyzedDocumentsAtom = atom({
  key: 'dashboardAnalyzedDocumentsAtom',
  default: {
    loading: false,
    items: [],
    error: null
  },
});

export const dashboardSeverityDataAtom = atom({
  key: 'dashboardSeverityDataAtom',
  default: {
    loading: false,
    items: [],
    error: null
  },
});
